import { Component, OnInit, AfterViewInit, ElementRef, Renderer, Input } from '@angular/core';
import { isBrowser } from 'angular2-universal';
import { CookieService } from 'angular2-cookie/core';
declare var $: any;

import { IntlService } from '../shared/intl.service';
import { ConfigService } from '../shared/config.service';
import { UtilsService } from '../shared/utils.service';

@Component({ 
  selector: 'policy-checker',
  template: require('./partials/cookie-consent.html')
})
export class CookieConsentComponent implements OnInit, AfterViewInit {

  @Input() language: string;
  hasConsented: boolean = true;

  private cookieName = 'cookie-consent';

  constructor(public intl: IntlService, private config: ConfigService, private utils: UtilsService, private cookieService: CookieService, private renderer: Renderer, private el: ElementRef){}

  ngOnInit(){
    // Check if policy has been accepted
    this.getConsent();
  }

  ngAfterViewInit() {
    if (isBrowser && !this.hasConsented) {  
      $.magnificPopup.open({ items: { src: '#'+this.cookieName }, type: 'inline'}); 
      $( ".mfp-bg" ).addClass( "mfp-black-bg" ); 
    }
  }

  onConsent(answser) {
    if (isBrowser) { 
      this.hasConsented = true;
      this.cookieService.put(this.cookieName, answser, {expires: this.utils.dateNowPlusDays(this.config.data.APP.LANGUAGES.COOKIE_DAY_AGE)});
      $( ".mfp-bg" ).removeClass( "mfp-black-bg" );
      $('#'+this.cookieName).magnificPopup('close');
    }
  }

  getConsent(){
    if(isBrowser){
      let cookie = this.cookieService.getObject(this.cookieName);
      if(cookie==undefined)
        this.hasConsented = false;
      // console.log('hasConsented', this.hasConsented);
      // console.log('agrees', cookie ? 'yes': 'no');
    }
  }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/front/cookie-consent.component.ts